import React, { useState } from "react";
import "./Auth.css";
import { useNavigate } from "react-router-dom";
import { commonStyles } from "../../utils/styles/CommonStyle";
import { Theme } from "../../theme/Theme";
import { Icon } from "@iconify/react";
import CommonButton from "../../components/common/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { ResetPasswordActionInitiate } from "../../redux/actions/auth/resetPasswordAction";
import { Loader } from "../../utils";
import { useFormik } from "formik";
import * as Yup from "yup";
import { strongPasswordValidation, confirmPasswordValidation } from "../../utils/validations";
import AuthLayout from "../../components/common/AuthLayout";

const SetPassword = () => {
  const [showPW, setShowPW] = useState(false);
  const [showCPW, setShowCPW] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.resetPassword);

  const formik = useFormik({
    initialValues: { password: "", confirmPassword: "" },
    validationSchema: Yup.object({
      password: strongPasswordValidation,
      confirmPassword: confirmPasswordValidation('password'),
    }),
    onSubmit: async (values) => {
      const result = await dispatch(
        ResetPasswordActionInitiate({
          password: values.password,
          password_confirmation: values.confirmPassword,
        })
      );

      if (result?.success) {
        localStorage.removeItem("token");
        localStorage.removeItem("auth_phone");
        navigate("/");
      }
    },
  });

  return (
    <AuthLayout
      title="Set New Password"
      subtitle="Enter and confirm your new account password."
      showTabs={false}
      showLegalLinks={false}
    >
      <form className="w-100" onSubmit={formik.handleSubmit} autoComplete="off">
        <div style={{ position: 'relative', marginTop: 8, display: 'flex', alignItems: 'center' }} className="mt-3">
          <input
            type={showPW ? "text" : "password"}
            name="password"
            placeholder="Password"
            autoComplete="current-password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{
              ...commonStyles.input,
              ...Theme.inputText,
              ...(formik.touched.password && formik.errors.password ? commonStyles.errorBorder : commonStyles.commonBorder)
            }}
          />
          <span
            style={{
              position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
              cursor: 'pointer', userSelect: 'none', marginTop: 4
            }}
            onClick={() => setShowPW(v => !v)}
            tabIndex={0}
            role="button"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setShowPW(v => !v);
              }
            }}
            aria-label={showPW ? "Hide password" : "Show password"}
          >
            <Icon icon={showPW ? "qlementine-icons:eye-crossed-16" : "mdi-light:eye"} width="20" height="20" style={{ marginBottom: 6 }} />
          </span>
        </div>
        {formik.touched.password && formik.errors.password && <div style={Theme.errorText}>{formik.errors.password}</div>}

        <div style={{ position: 'relative', marginTop: 8, display: 'flex', alignItems: 'center' }} className="mt-3">
          <input
            type={showCPW ? "text" : "password"}
            name="confirmPassword"
            placeholder="Confirm Password"
            autoComplete="current-password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{
              ...commonStyles.input,
              ...Theme.inputText,
              ...(formik.touched.confirmPassword && formik.errors.confirmPassword ? commonStyles.errorBorder : commonStyles.commonBorder)
            }}
          />
          <span
            style={{
              position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
              cursor: 'pointer', userSelect: 'none', marginTop: 4
            }}
            onClick={() => setShowCPW(v => !v)}
            tabIndex={0}
            role="button"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setShowCPW(v => !v);
              }
            }}
            aria-label={showCPW ? "Hide password" : "Show password"}
          >
            <Icon icon={showCPW ? "qlementine-icons:eye-crossed-16" : "mdi-light:eye"} width="20" height="20" style={{ marginBottom: 6 }} />
          </span>
        </div>
        {formik.touched.confirmPassword && formik.errors.confirmPassword && <div style={Theme.errorText}>{formik.errors.confirmPassword}</div>}

        <div className="mt-4">
          <CommonButton
            title={
              (loading || formik.isSubmitting) ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  <Loader variant="dots" size="small" color="white" />
                  <span>Saving...</span>
                </div>
              ) : "Save Password"
            }
            type="submit"
            width={"100%"}
            disabled={loading || formik.isSubmitting}
          />
        </div>
      </form>
    </AuthLayout>
  );
};

export default SetPassword;
